import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {
        noOffsetOnActive: true,
    },
    styleOverrides: {
        root: {
            margin: "0",
            borderRadius: "0",
            "&:hover:not(.active)": {
                background: theme.palette.secondary.main,
                " svg": {
                    opacity: "1",
                },
                " img": {
                    opacity: "1",
                },
            },
            "&.active": {
                backgroundColor: "transparent",
                color: theme.palette.common.black,
                "& svg": {
                    fill: theme.palette.highlight.main,
                    background: "transparent",
                },
            },
            "&.central-ordering": {
                borderRight: `1px solid ${theme.palette.secondary.main}`,
            },
            "&.user-settings": {
                borderRight: `1px solid ${theme.palette.secondary.main}`,
            },
        },
        icon: {
            opacity: ".7",
        },
        image: {
            opacity: ".7",
        },
    },
})
